<template>
  <div class="onboarding">
    <transition name="fade">
      <delete-account-popup v-if="showDeleteAccount" @close="showDeleteAccount = false" @account-deleted="(payload) => accountDeleted(payload.password)" />
    </transition>
    <img class="logo" src="@/assets/logo.svg" alt="Clavo" width="153" height="33" @click="pushToHome" />
    <div class="onboarding-wrapper">
      <div class="contents">
        <div class="main">
          <!-- <div class="back-button-wrapper">
            <a
              v-if="showBackButton"
              class="back-button"
              @click="handleBackButton"
            >
              <img src="@/assets/_desktop/_calendars/DP-Arrow.svg">
              <span>{{ $t('back') }}</span>
            </a>
          </div> -->
          <div v-if="stage === 'invitation'" class="choose-path">
            <h1 class="h-subtitle">{{ $t('hiUser', { name: fullname }) }} <span class="emoji">👋</span></h1>
            <p class="subtitle">{{ $t('youHaveBeenAlreadyInvited') }}</p>

            <button class="clavo-button secondary" @click="acceptInvite">
              <span>
                {{ $t('join') }}&nbsp;&nbsp;
                <span>
                  <team-icon :team="teamInvited" class="team-icon" />
                  {{ teamInvited.name }}
                </span>
              </span>
              <svg width="22" height="21" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.161 10.145l-.007-.012a.75.75 0 00-.124-.163l-9-9a.75.75 0 00-1.133.976l.073.084 7.72 7.72H1.5a.75.75 0 00-.102 1.493l.102.007h17.189l-7.72 7.72a.75.75 0 00.977 1.133l.084-.073 9-9 .064-.072a.753.753 0 00.007-.01l-.07.082a.753.753 0 00.16-.238l.009-.021a.746.746 0 00.005-.014l.007-.02a.748.748 0 00.038-.237v-.016c0-.02-.002-.041-.004-.061l.004.077a.756.756 0 00-.015-.148 1.325 1.325 0 00-.018-.073l-.005-.014-.004-.013a.746.746 0 00-.041-.096l-.006-.01z"
                  fill="#4B61EE"
                  fill-rule="nonzero"
                />
              </svg>
            </button>
            <button class="clavo-button primary" @click="pushToStage('team')">
              {{ $t('addNewTeam') }}
              <svg width="22" height="21" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.161 10.145l-.007-.012a.75.75 0 00-.124-.163l-9-9a.75.75 0 00-1.133.976l.073.084 7.72 7.72H1.5a.75.75 0 00-.102 1.493l.102.007h17.189l-7.72 7.72a.75.75 0 00.977 1.133l.084-.073 9-9 .064-.072a.753.753 0 00.007-.01l-.07.082a.753.753 0 00.16-.238l.009-.021a.746.746 0 00.005-.014l.007-.02a.748.748 0 00.038-.237v-.016c0-.02-.002-.041-.004-.061l.004.077a.756.756 0 00-.015-.148 1.325 1.325 0 00-.018-.073l-.005-.014-.004-.013a.746.746 0 00-.041-.096l-.006-.01z"
                  fill="#FFFFFF"
                  fill-rule="nonzero"
                />
              </svg>
            </button>
          </div>
          <div v-if="stage == 'createOrDelete'" class="createOrDelete">
            <h1>{{ $t('createOrDeleteTitle') }}</h1>

            <p class="confirmation">
              {{ $t('chooseDeleteAccountOrCreateNewTeam') }}
            </p>
            <div class="button-row">
              <button class="clavo-button secondary" @click="createNewTeamPressed">
                {{ $t('createNewTeam') }}
              </button>
              <button class="clavo-button clavo-button-danger-primary" @click="deleteAccountPressed">
                {{ $t('deleteAccount') }}
              </button>
            </div>
          </div>
          <div v-if="stage == 'team'" class="team">
            <h1>{{ $t('whatIsTheNameOfCompanyOrTeam') }}</h1>
            <editable-input
              id="fullname"
              v-model="team"
              input-type="text"
              :name-to-save="'organization'"
              auto-capitalize="words"
              autofocus
              :placeholder="$t('teamNamePlaceholder')"
              @keyup.enter.native="createTeam"
            />

            <!-- <input type="text" id="team" v-model="team" placeholder="E.g. Acme" required autofocus/> -->

            <button :class="{ inactive: team == '' || isLoading }" class="clavo-button big primary" @click="createTeam">
              {{ $t('next') }}
            </button>
          </div>
          <locations-where-you-work v-if="stage === 'locations'" :team-id="teamId" @push-to-next-stage="getTagLocations" />
          <add-offices
            v-if="stage === 'offices'"
            :added-offices="addedOffices"
            @update-offices="
              (offices) => {
                addedOffices = offices
              }
            "
            @push-to-next-stage="pushToStage('deadline')"
          />
          <!--
          <div v-if="stage == 'limits'" class="limits">
            
            <h1>What is your work week? How many holidays do you have?</h1>

            <label for="hours">Working hours</label>
            <input id="hours" v-model="hours" type="text" required autofocus />
            <div class="units">per week</div>

            <label for="hours">Holidays</label>
            <input id="holidays" v-model="holidays" type="text" required autofocus />
            <div class="units">per year</div>

            <button class="clavo-button clavo-button-high active" :class="{ inactive: isLoading }" @click="setTeamDefaults">
              {{ $t('next') }}
            </button>
          </div>
          -->

          <div v-if="stage == 'deadline'" class="deadline">
            <h1>{{ $t('deadlineToSubmitWorkingHours') }}</h1>

            <div class="deadline-controls">
              <span class="each">{{ $t('deadlineEach') }}</span>
              <Dropdown
                v-model="teamObj.settings['submit-deadline-day']"
                class="day-dropdown"
                input-class="large"
                :options="weekdays(1)"
                :dbname="'submit-deadline-day'"
                dont-save
              />
              <span class="at">{{ $t('deadlineAt') }}</span>
              <time-dropdown v-model="teamObj.settings['submit-deadline-time']" :editable="false" :count="24" input-class="large" class="time-dropdown" />
            </div>

            <button class="clavo-button big primary" :class="{ inactive: isLoading }" @click.prevent="setDeadline">
              {{ $t('next') }}
            </button>
          </div>

          <div v-if="stage == 'invite'" class="invite">
            <h1>{{ $t('invitePeople') }}</h1>
            <invitation-form :team="teamObj" :team-id="teamId" onboarding mode="invite" class="inline" @done="pushToStage('done')" />
          </div>

          <div v-if="stage == 'done'" class="done">
            <h1>🎉<br />{{ $t('thanksForStarting30DayTrial') }}</h1>
            <p>{{ $t('fromNowOnClavoWillSyncAllYourTeamSchedules') }}</p>
            <ul>
              {{
                $t('thingsToKnow')
              }}
              <li>{{ $t('youCanAddNowUnlimitedUsers') }}</li>
              <li>{{ $t('after30DaysClavoWillBeDowngraded') }}</li>
            </ul>
            <button class="clavo-button primary big" :class="{ inactive: isLoading }" @click="pushToDashBoard">
              {{ $t('goToYourTeam') }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="!(stage === 'locations' || stage === 'offices' || stage === 'invitation')" class="tips" :class="{ narrow: stage == 'deadline' }">
        <div v-if="stage == 'team'" class="team">
          <div class="callout">
            <p>
              <span v-html="$t('hiUserEmoji', { name: fullname, EMOJI_CLAP_HANDS: getEmoji('EMOJI_CLAP_HANDS') })" />
              <br />
              {{ $t('whatIsYourTeamCalled') }}
            </p>
          </div>
          <img src="@/assets/illustrations/sloth-w-coffee.svg" alt="Clavo, a sloth with coffee" />
        </div>
        <!--        <div-->
        <!--          v-if="stage == 'locations'"-->
        <!--          class="locations"-->
        <!--        >-->
        <!--          <div class="tips-list">-->
        <!--            <p>💡Tips</p>-->
        <!--            <ul>-->
        <!--              <li>Add your offices and workplaces.</li>-->
        <!--              <li>Any type of name is ok as long as other members easily recognize it.</li>-->
        <!--              <li>If your offices are in different time zones, please make sure to set them up correctly.</li>-->
        <!--              <li>You can always change names, add and remove locations later, in the settings section.</li>-->
        <!--            </ul>-->
        <!--          </div>-->
        <!--        </div>-->
        <!-- 
        <div
          v-if="stage == 'limits'"
          class="limits"
        >
          <div class="tips-list">
            <p>💡Tips</p>
            <ul>
              <li>You can adjust those values individually for each teammate later.</li>
              <li>By default, everybody can adjust their limits.</li>
              <li>More options available in settings.</li>
            </ul>
          </div>
        </div> -->

        <div v-if="stage == 'deadline'" class="deadline">
          <div class="callout">
            <p v-html="$t('weWillRemindYourTeammatesToUpdateSchedule', { EMOJI_CLOCK: getEmoji('EMOJI_CLOCK') })" />
          </div>
          <img src="@/assets/illustrations/sloth-w-clock.svg" alt="Clavo, a sloth with coffee" />
        </div>

        <div v-if="stage == 'invite'" class="invite" />

        <div v-if="stage == 'done'" class="done">
          <img src="@/assets/illustrations/sloth-hangover.svg" alt="Clavo, say goodbye to spreadsheets" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Parse from 'parse'
import User from '@/components/User'
import Validation from '@/components/Validation'
import Dropdown from '@/components/UI/Dropdown'
import TimeDropdown from '@/components/UI/TimeDropdown'
import moment from 'moment'
import InvitationForm from '@/components/Team/InvitationForm'
import ParseFunctions from '@/components/ParseFunctions'
import EditableInput from '@/components/UI/EditableInput'
import EventBus from '@/EventBus'
import Constants from '@/components/Constants'
import LocationsWhereYouWork from '@/views/OnBoardingComponents/LocationsWhereYouWork'
import AddOffices from '@/views/OnBoardingComponents/AddOffices'
import TeamIcon from '@/components/Team/TeamIcon'
import DeleteAccountPopup from '@/components/Settings/DeleteAccountPopup'

export default {
  name: 'Onboarding',

  components: {
    AddOffices,
    LocationsWhereYouWork,
    Dropdown,
    TimeDropdown,
    InvitationForm,
    EditableInput,
    TeamIcon,
    DeleteAccountPopup,
  },

  mixins: [User, Validation, ParseFunctions, Constants],

  data() {
    return {
      team: '',
      teams: undefined,
      teamObj: null,
      teamId: null,
      hours: 40,
      holidays: 20,
      stage: 'team',
      emails: ['', '', ''],
      emailsValid: [],
      allValid: true,
      addedOffices: [],
      timezones: null,
      timezonesLoaded: false,
      teamInvited: undefined,
      isLoading: false,
      showDeleteAccount: false,
    }
  },

  computed: {
    showBackButton() {
      return !['team', 'locations', 'done'].includes(this.stage)
    },
  },

  async created() {
    // this.deadlineTime = moment().hours(10).minutes(0).toISOString()
    // console.log('this.deadlineTime', this.deadlineTime)
    if (this.$route.query.stage) {
      this.stage = this.$route.query.stage
    }
    if (this.$route.query.teamId) {
      this.teamId = this.$route.query.teamId
    }

    let res = await this.getTeams()
    if (res.status === 'ok') {
      this.teams = res.teams
      if (this.stage === 'locations' || this.stage === 'deadline') {
        if (this.$store.state.createdTeamId) {
          this.teamObj = this.teams.find((x) => x.teamId === this.$store.state.createdTeamId)
        }
      }

      if (this.teams.length !== 0 && this.stage === 'team') {
        this.teamInvited = this.teams.find((x) => x.isInvited)
        if (this.teamInvited) {
          this.stage = 'invitation'
        }
      }

      this.validateEmails()
      this.timezones = await this.getFormattedTimezones()
    } else {
      this.showServerError(res)
    }
  },

  mounted() {
    window.onpopstate = function () {
      location.reload()
    }
    EventBus.$on('reload-teams', this.reloadTeamsToCheckServerConnection)
  },

  beforeDestroy() {
    EventBus.$off('reload-teams', this.reloadTeamsToCheckServerConnection)
  },

  methods: {
    async reloadTeamsToCheckServerConnection() {
      let res = await this.getTeams()
      if (res.status !== 'ok') {
        this.showServerError(res)
      }
    },
    async getTagLocations(args) {
      if (args.office.checked) {
        await this.pushToStage('offices')
      } else {
        await this.pushToStage('deadline')
      }
    },
    async acceptInvite() {
      let res = await this.acceptExistingUserInvitation(this.teamInvited.teamId)
      if (res.status !== 'ok') {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('joiningTeamFailed', { x: this.teamInvited.teamId }),
          error: true,
        })
      } else {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('successfullyJoinedTeam', { x: this.teamInvited.teamId }),
        })
      }
      await this.$router.push({
        path: '/',
      })
    },
    async createTeam() {
      if (this.isLoading) return // block double click
      this.isLoading = true
      this.$store.commit('setShowProgressBar', true)
      if (this.team != '') {
        if (this.$store.state.createdTeamId) {
          let res = await this.setTeamName(this.$store.state.createdTeamId, this.team)
          if (res.status === 'ok') {
            this.teamId = this.$store.state.createdTeamId
            await this.pushToStage('locations')
          } else {
            this.showServerError(res)
          }
          this.isLoading = false
        } else {
          var res = await this.createTeamParse(this.team)
          if (res.status === 'ok') {
            this.teamObj = res.newTeam
            this.teamId = res.newTeam.id
            this.teamObj.settings = this.teamObj.get('settings')
            this.$store.commit('setCreatedTeamId', this.teamId)
            await this.pushToStage('locations')
            await this.$store.dispatch('reloadTeams')
          } else {
            this.showServerError(res)
          }
          this.isLoading = false
        }
      }
      this.$store.commit('setShowProgressBar', false)
    },
    async setTeamDefaults() {
      if (this.isLoading) return // block double click
      this.isLoading = true

      let res1 = await this.updateTeamSettings(this.teamId, 'default-holiday-days-yearly', this.holidays)
      if (res1.status !== 'ok') this.showServerError(res1)

      let res2 = await this.updateTeamSettings(this.teamId, 'default-working-hours-weekly', this.hours)
      if (res2.status !== 'ok') this.showServerError(res2)

      if (res1.status === 'ok' && res2.status === 'ok') await this.pushToStage('deadline')

      this.isLoading = false
    },
    async setDeadline() {
      if (this.isLoading) return // block double click
      this.isLoading = true
      let settings = this.teamObj.settings
      let deadlineSettings = {
        'submit-deadline-day': settings['submit-deadline-day'],
        'submit-deadline-time': settings['submit-deadline-time'],
      }
      let res = await this.updateTeamSettingsCollectively(this.teamId, deadlineSettings, 'initial')
      if (res.status === 'ok') await this.pushToStage('invite')

      this.isLoading = false
    },
    async createNewTeamPressed() {
      this.stage = 'team'
    },
    async accountDeleted(password) {
      this.showDeleteAccount = false
      let userId = Parse.User.current().id
      let res = await this.deleteUser(password)
      if (res.status === 'ok') {
        this.showMessage('accountDeleted')
        await this.parseLogout()
        await this.$router.push({
          path: 'account-deletion',
          query: { id: userId },
        })
      } else {
        this.showServerError(res, 'accountDeleteError')
      }
    },
    async deleteAccountPressed() {
      this.showDeleteAccount = true
    },
    addEmail() {
      this.emails.push('')
      this.validateEmails()
    },
    deleteEmail(index) {
      this.emails.splice(index, 1)
      this.emailsValid.splice(index, 1)
      this.validateEmails()
    },
    validateEmails() {
      let allValid = true
      let allEmpty = true
      for (var i = 0; i < this.emails.length; i++) {
        if (this.emails[i] !== '') allEmpty = false
        let valid = this.emails[i] === '' || this.emailValid(this.emails[i])
        this.$set(this.emailsValid, i, valid)
        allValid = allValid && valid
      }

      this.allValid = allValid && !allEmpty
      // console.log(this.emailsValid, this.allValid)
    },
    async invite() {
      this.$store.commit('setShowProgressBar', true)
      if (process.env.IS_TESTING_SERVER) {
        await Parse.Cloud.run('setTestingHostAndPort', { host: location.protocol + '//' + location.host }, {})
      }

      for (var i = 0; i < this.emails.length; i++)
        if (this.emails[i] != '') {
          let res = await this.addTeamMember(this.emails[i], this.teamId, null, '')
          if (res.status !== 'ok') this.showServerError(res)
        }

      this.$store.commit('setShowProgressBar', false)
      await this.pushToStage('done')
    },
    async pushToDashBoard() {
      if (this.isLoading) return // block double click
      this.isLoading = true
      this.$store.commit('setCreatedTeamId', undefined)
      await this.$router.push({
        path: '/',
        name: 'Dashboard',
        query: {
          teamId: this.teamId,
        },
        hash: '#Calendar',
      })
      this.isLoading = false
    },
    async pushToStage(stage) {
      if (stage === 'done') {
        let res
        for (const office of this.addedOffices) {
          let timezone = this.timezones.find((x) => x.value === office.timezone).value
          res = await this.addLocation(office.name, office.color, this.teamId, true, timezone, 'office')
          if (res.status !== 'ok') {
            EventBus.$emit('new-info-bar-msg', {
              msg: this.$t('addingLocationFailed'),
              error: true,
            })
          }
        }
      }
      this.stage = stage
      await this.$router.push({
        name: 'Onboarding',
        query: {
          stage: this.stage,
          teamId: this.teamId,
        },
      })
    },
    async pushToHome() {
      await this.$router.push('/')
    },
    async handleBackButton() {
      switch (this.stage) {
        case 'invite':
          await this.pushToStage('deadline')
          break
        case 'deadline':
          if (this.addedOffices.length > 0) {
            await this.pushToStage('offices')
          } else {
            await this.pushToStage('locations')
          }
          break
        case 'offices':
          this.addedOffices = []
          await this.pushToStage('locations')
          break
        default:
          break
      }
    },
  },
}
</script>
<style lang="scss">
// Use big inputs
.onboarding {
  @include input-big;
  @include dropdown-big;
}
button:hover .team-icon .default-team-icon {
  background-color: white;
  p {
    color: $blue;
  }
}
</style>
<style lang="scss" scoped>
.logo {
  align-self: flex-start;
  order: 0;
  margin: 30px;
  cursor: pointer;
}

.onboarding-wrapper {
  max-width: 960px;
  width: 100%;
  padding: 0 30px 100px 30px;
  margin: 100px auto 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  @include respond-below(xs) {
    margin-top: 48px;
  }

  .contents {
    display: flex;
    flex-direction: column;
    flex: 3;

    h1 {
      margin-bottom: 48px;
      &.h-subtitle {
        margin-bottom: 12px;
      }
    }

    .main {
      margin: auto 0;
      position: relative;

      .back-button-wrapper {
        position: absolute;
        left: 0px;
        top: -50px;
        .back-button {
          display: flex;
          align-items: center;
          background-color: $white;
          cursor: pointer;
          padding: 8px 0px;
          opacity: 0.4;
          transition: opacity 0.15s;
          &:hover {
            opacity: 1;
          }
          span {
            font-family: $bold;
            color: $blue;
            font-size: 16px;
          }
          img {
            height: 16px;
          }
        }
      }

      .units {
        color: $flax-bloom;
        font-size: 14px;
      }

      button {
        margin-top: 60px;
        margin-bottom: 36px;

        @include respond-below(md) {
          width: 100%;
        }
      }

      .skip {
        // positioning skip next to a button
        position: relative;
        font-size: 16px;
        letter-spacing: 0.2px;

        @include respond-below(xs) {
          text-align: center;
        }

        a {
          font-family: $semibold;
        }
      }

      .subtitle {
        font-size: 16px;
        font-family: $regular;
        line-height: 24px;
        margin-bottom: 48px;
      }
      .choose-path {
        button {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 0;
          margin-bottom: 12px;
          width: 50%;
          min-height: 90px;
          text-align: left;
          @include respond-below(sm) {
            width: 100%;
          }
          svg {
            flex: 0 0 22px;
          }
          &.secondary:hover {
            svg path {
              fill: #fff;
            }
            span span {
              color: white;
            }
          }
          &.primary:hover {
            svg path {
              fill: $blue;
            }
          }

          span {
            font-family: $bold;
            line-height: 24px;

            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .team-icon {
              margin-right: 6px;
            }
          }
        }
      }

      .createOrDelete {
        .button-row {
          margin-top: 48px;
          button {
            flex: 1;
            margin-top: 0px;
            &:first-of-type {
              margin-right: 20px;
            }
          }
        }
      }

      .deadline {
        //padding-right: 25%;
        &-controls {
          display: flex;
          justify-content: space-between;

          .at,
          .each {
            color: $bluebell;
            font-size: 20px;
            line-height: 48px;
            display: block;
          }
          .at {
            margin: 0 18px;
          }
          .each {
            margin: 0 18px 0 0;
          }

          @include respond-below(md) {
            flex-direction: column;
            .at,
            .each {
              margin: 0;
            }
          }
        }
      }

      .done {
        p {
          font-size: 18px;
          line-height: 30px;
          margin-top: -12px;
        }
        ul {
          font-size: 16px;
          line-height: 30px;
          list-style: none;
          margin: 30px 0px 0;
          padding: 0;
          li {
            margin-left: 30px;
            margin-top: 6px;
            position: relative;
            &::before {
              content: '\2022';
              color: $blue;
              font-family: $bold;
              font-size: 24px;
              display: inline-block;
              position: absolute;
              left: -20px;
            }
          }
        }
      }
    }
  }

  .tips {
    @include respond-below(sm) {
      display: none;
    }
    display: flex;
    justify-content: flex-end;
    flex: 3;
    &.narrow {
      flex: 2;
    }

    .tips-list {
      margin: auto 100px;
      color: $bluebell;

      p {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 24px;
      }

      ul {
        padding-left: 24px;

        li {
          font-weight: 16px;
          margin-bottom: 24px;
        }
      }
    }

    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;

      .callout {
        display: flex;
        justify-content: flex-end;
        p {
          display: block;
          padding: 12px 24px;
          background-color: $white-lilac;
          color: $black;
          font-family: $bold;
          font-size: 20px;
          line-height: 25px;
          border-radius: 10px;
          margin: 0 0 30px 0;
          position: relative;

          span {
            font-family: $bold;
          }
          .emoji {
            margin-right: 2px;
          }
          &:after {
            content: '';
            bottom: -30px;
            left: 25%;
            //right: 0px;
            width: 30px;
            height: 30px;
            position: absolute;
            display: block;
            background: url(~@/assets/layout/callout-tip.svg) no-repeat;
          }
        }
      }
      img {
        width: 250px;
        @include respond-below(md) {
          width: 225px;
        }
      }

      &.deadline {
        .callout {
          p {
            width: 80%;
          }
        }
      }

      &.done {
        img {
          width: 90%;
        }
      }
    }
  }
}
</style>
